<p-toast key="session-expired" />
<router-outlet></router-outlet>